/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ECardType {
  AUDIO = "AUDIO",
  FACEBOOK = "FACEBOOK",
  GIF = "GIF",
  IMAGE = "IMAGE",
  INSTAGRAM = "INSTAGRAM",
  LINK = "LINK",
  LINKEDSTORIES = "LINKEDSTORIES",
  MAP = "MAP",
  MARKDOWN = "MARKDOWN",
  MINORTEXT = "MINORTEXT",
  TEXT = "TEXT",
  TWITTER = "TWITTER",
  VIDEO = "VIDEO",
}

export enum ECloneWorldMarkerStoryCloneType {
  DUPLICATE_STORY = "DUPLICATE_STORY",
  EMPTY = "EMPTY",
  SAME_STORY = "SAME_STORY",
}

export enum EDeepAiStyle {
  S_3D_CHARACTER_GENERATOR = "S_3D_CHARACTER_GENERATOR",
  S_3D_OBJECTS_GENERATOR = "S_3D_OBJECTS_GENERATOR",
  S_ABSTRACT_PAINTING_GENERATOR = "S_ABSTRACT_PAINTING_GENERATOR",
  S_ANIME_PORTRAIT_GENERATOR = "S_ANIME_PORTRAIT_GENERATOR",
  S_ANIME_WORLD_GENERATOR = "S_ANIME_WORLD_GENERATOR",
  S_COMICS_PORTRAIT_GENERATOR = "S_COMICS_PORTRAIT_GENERATOR",
  S_CONTEMPORARY_ARCHITECTURE_GENERATOR = "S_CONTEMPORARY_ARCHITECTURE_GENERATOR",
  S_CUTE_CREATURE_GENERATOR = "S_CUTE_CREATURE_GENERATOR",
  S_CYBERPUNK_GENERATOR = "S_CYBERPUNK_GENERATOR",
  S_CYBERPUNK_PORTRAIT_GENERATOR = "S_CYBERPUNK_PORTRAIT_GENERATOR",
  S_FANTASY_CHARACTER_GENERATOR = "S_FANTASY_CHARACTER_GENERATOR",
  S_FANTASY_PORTRAIT_GENERATOR = "S_FANTASY_PORTRAIT_GENERATOR",
  S_FANTASY_WORLD_GENERATOR = "S_FANTASY_WORLD_GENERATOR",
  S_FUTURE_ARCHITECTURE_GENERATOR = "S_FUTURE_ARCHITECTURE_GENERATOR",
  S_HOLOGRAM_3D_GENERATOR = "S_HOLOGRAM_3D_GENERATOR",
  S_IMPRESSIONISM_PAINTING_GENERATOR = "S_IMPRESSIONISM_PAINTING_GENERATOR",
  S_LOGO_GENERATOR = "S_LOGO_GENERATOR",
  S_OLD_STYLE_GENERATOR = "S_OLD_STYLE_GENERATOR",
  S_ORIGAMI_3D_GENERATOR = "S_ORIGAMI_3D_GENERATOR",
  S_PIXEL_ART_GENERATOR = "S_PIXEL_ART_GENERATOR",
  S_POP_ART_GENERATOR = "S_POP_ART_GENERATOR",
  S_RENAISSANCE_PAINTING_GENERATOR = "S_RENAISSANCE_PAINTING_GENERATOR",
  S_STEAMPUNK_GENERATOR = "S_STEAMPUNK_GENERATOR",
  S_STREET_ART_GENERATOR = "S_STREET_ART_GENERATOR",
  S_SURREAL_GRAPHICS_GENERATOR = "S_SURREAL_GRAPHICS_GENERATOR",
  S_SURREAL_PORTRAIT_GENERATOR = "S_SURREAL_PORTRAIT_GENERATOR",
  S_TEXT2IMG = "S_TEXT2IMG",
  S_WATERCOLOR_ARCHITECTURE_GENERATOR = "S_WATERCOLOR_ARCHITECTURE_GENERATOR",
  S_WATERCOLOR_PAINTING_GENERATOR = "S_WATERCOLOR_PAINTING_GENERATOR",
}

export enum EEventFormFieldType {
  BOOLEAN = "BOOLEAN",
  EMAIL = "EMAIL",
  HEADLINE = "HEADLINE",
  IMAGE = "IMAGE",
  INFO_TEXT = "INFO_TEXT",
  MULTI_OPTIONS = "MULTI_OPTIONS",
  RADIO = "RADIO",
  STRING = "STRING",
  STRING_MULTILINE = "STRING_MULTILINE",
  URL = "URL",
}

export enum EGptRole {
  SYSTEM = "SYSTEM",
  USER = "USER",
}

export enum ESubscriptionDetailStatus {
  ACTIVE = "ACTIVE",
  CANCELED = "CANCELED",
  CANCEL_SCHEDULED = "CANCEL_SCHEDULED",
  PAYMENT_REQUIRED = "PAYMENT_REQUIRED",
}

export enum ESubscriptionTier {
  FREE = "FREE",
  FULL = "FULL",
  TIER_V1_LEVEL_1 = "TIER_V1_LEVEL_1",
  TIER_V1_LEVEL_2 = "TIER_V1_LEVEL_2",
}

export enum EUserEditorAccessLevel {
  FREE = "FREE",
  FULL = "FULL",
}

export enum EUserRole {
  ADMIN = "ADMIN",
  RESELLER = "RESELLER",
  USER = "USER",
}

export enum EVisibility {
  LINK = "LINK",
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC",
}

export enum EWorldMapBookingConfigurationFieldType {
  BOOLEAN = "BOOLEAN",
  EMAIL = "EMAIL",
  HEADLINE = "HEADLINE",
  STRING = "STRING",
}

export enum EWorldMapInitialType {
  AUTOMATIC = "AUTOMATIC",
  CUSTOM = "CUSTOM",
}

export enum EWorldMapMarkerType {
  DIRECTION = "DIRECTION",
  DRAW = "DRAW",
  IMAGE = "IMAGE",
  INDOOR_STAND = "INDOOR_STAND",
  LINK = "LINK",
  PIN = "PIN",
  POLYGON = "POLYGON",
  REACT = "REACT",
  ROUTE = "ROUTE",
  TEXT = "TEXT",
  V2_ICON = "V2_ICON",
  V2_IMAGE = "V2_IMAGE",
  V2_LINE = "V2_LINE",
  V2_POLYGON = "V2_POLYGON",
  V2_ROUTE = "V2_ROUTE",
  V2_TEXT = "V2_TEXT",
  V2_VARIANT_ICON = "V2_VARIANT_ICON",
  V2_WALL = "V2_WALL",
  YOUTUBE = "YOUTUBE",
}

export enum EWorldMapSetType {
  CATEGORY = "CATEGORY",
  FLOOR = "FLOOR",
  TIME = "TIME",
}

export enum WorldMapMarkerDetailStyle {
  BUBBLE = "BUBBLE",
  MAP_V2 = "MAP_V2",
  MINI = "MINI",
  STYLE1 = "STYLE1",
}

export interface AudioInput {
  fileUrl?: string | null;
}

export interface CardInfoInput {
  title?: string | null;
  description?: string | null;
  date?: any | null;
  collapsed?: boolean | null;
  customConfig?: string | null;
}

export interface CardInputWithType {
  info?: CardInfoInput | null;
  video?: VideoInput | null;
  images?: (ImageInput | null)[] | null;
  links?: (LinkInput | null)[] | null;
  location?: LocationInput | null;
  gif?: GifInput | null;
  twitter?: TwitterInput | null;
  instagram?: InstagramInput | null;
  linkedStories?: LinkedStoriesInput | null;
  facebook?: FacebookInput | null;
  markdown?: MarkdownInput | null;
  audio?: AudioInput | null;
  type?: ECardType | null;
  image?: ImageCardInput | null;
}

export interface ChangeUserSubscriptionByAdminInput {
  userAccessLevel?: EUserEditorAccessLevel | null;
}

export interface CoordinatesInput {
  lat?: number | null;
  lng?: number | null;
}

export interface EventFormFieldInput {
  fieldId: string;
  title: string;
  text?: string | null;
  placeholder?: string | null;
  type: EEventFormFieldType;
  options?: EventFormFieldOptionInput[] | null;
  validation?: EventFormFieldValidationInput | null;
}

export interface EventFormFieldOptionInput {
  title: string;
  optionId: string;
}

export interface EventFormFieldValidationInput {
  required?: boolean | null;
  maxLength?: number | null;
}

export interface EventFormInput {
  title: string;
  thankYouMessage?: string | null;
  allowSubmitMultiple?: boolean | null;
  fields: EventFormFieldInput[];
}

export interface EventUserInformationInput {
  firstName?: string | null;
  lastName?: string | null;
  linkedIn?: string | null;
  photoUrl?: string | null;
  publicDescription?: string | null;
  websiteUrl?: string | null;
  companyName?: string | null;
  jobPosition?: string | null;
  networkingTopicOptionIds?: string[] | null;
}

export interface FacebookInput {
  postId?: string | null;
}

export interface GifInput {
  gifUrl?: string | null;
}

export interface GptMessage {
  role: EGptRole;
  content: string;
}

export interface GuideEntityTypeInput {
  name?: string | null;
  icon?: string | null;
  description?: string | null;
  linkUrl?: string | null;
  linkText?: string | null;
  listViewType?: string | null;
  sectionSetIds?: (string | null)[] | null;
  searchable?: boolean | null;
  isMapEntity?: boolean | null;
  order?: number | null;
}

export interface GuideExternalLinkInput {
  title?: string | null;
  url?: string | null;
}

export interface GuideInput {
  title?: string | null;
  welcomeMessage?: string | null;
  guideType?: string | null;
  logoUrl?: string | null;
  headerImageUrl?: string | null;
  styleColors?: GuideStyleColorInput[] | null;
  visualStyleId?: string | null;
  entitiesEnabled?: boolean | null;
  programEnabled?: boolean | null;
  infoEnabled?: boolean | null;
  availableLanguages?: string[] | null;
  worldMapEnabled?: boolean | null;
  worldMapPreviewUrl?: string | null;
  programExtensionHours?: number | null;
  metaTitle?: string | null;
  metaImageUrl?: string | null;
  metaDescription?: string | null;
  dateTimeStart?: any | null;
  dateTimeEnd?: any | null;
  scannableStoryIds?: string[] | null;
  roomOrderIds?: string[] | null;
  navigationBarPc?: string[] | null;
  navigationBarMobile?: string[] | null;
  navigationTilesLarge?: string[] | null;
  navigationTilesSmall?: string[] | null;
  language?: string | null;
  navigation?: GuideNavigationInput | null;
}

export interface GuideNavigationInput {
  tabs?: GuideNavigationRowInput[] | null;
  drawer?: GuideNavigationRowInput[] | null;
  homepagePrimaryModule?: GuideNavigationRowInput[] | null;
}

export interface GuideNavigationRowInput {
  navigationRowId: string;
  type: string;
  referenceId?: string | null;
  highlighted?: boolean | null;
  showDynamicNumber?: boolean | null;
  iconOverride?: string | null;
  titleOverride?: string | null;
  url?: string | null;
}

export interface GuideNewsfeedItemInput {
  title?: string | null;
  description?: string | null;
}

export interface GuideProgramItemInput {
  importKey?: string | null;
  date?: string | null;
  timeStart?: string | null;
  timeEnd?: string | null;
  title?: string | null;
  description?: string | null;
  loadDetailFromStoryId?: boolean | null;
}

export interface GuideStyleColorInput {
  colorId: string;
  value: string;
}

export interface ImageCardInput {
  containImage?: boolean | null;
}

export interface ImageInput {
  imageUrl?: string | null;
  fullImageUrl?: string | null;
  description?: string | null;
}

export interface InstagramInput {
  postId?: string | null;
}

export interface LinkInput {
  title?: string | null;
  url?: string | null;
}

export interface LinkedStoriesInput {
  storyIds?: string[] | null;
}

export interface LocationInput {
  title?: string | null;
  zoom?: number | null;
  center?: CoordinatesInput | null;
  markers?: (LocationMarkerInput | null)[] | null;
}

export interface LocationMarkerInput {
  lat?: number | null;
  lng?: number | null;
  addressLabel?: string | null;
}

export interface MarkdownInput {
  text?: string | null;
}

export interface MarkerOrderInput {
  worldMapMarkerId: string;
  order: number;
}

export interface StoryHeaderInput {
  title?: string | null;
  text?: string | null;
  imageUrl?: string | null;
  imageStyleId?: string | null;
}

export interface StoryInput {
  header?: StoryHeaderInput | null;
  ascending?: boolean | null;
  importKey?: string | null;
  category?: string | null;
  cardOrder?: (string | null)[] | null;
  worldMapId?: string | null;
}

export interface TwitterInput {
  postId?: string | null;
}

export interface UserInfoEditInput {
  firstName?: string | null;
  lastName?: string | null;
  imageUrl?: string | null;
  userAccessLevel?: EUserEditorAccessLevel | null;
}

export interface UserInfoRegisterInput {
  firstName?: string | null;
  lastName?: string | null;
}

export interface VideoInput {
  videoId?: string | null;
}

export interface WorldMapInitialInput {
  lat?: number | null;
  lng?: number | null;
  zoom?: number | null;
  rotation?: number | null;
  pitch?: number | null;
  useBounds?: boolean | null;
  bounds?: WorldMapInitialInputBoundsInput | null;
  autoBounds?: WorldMapInitialInputBoundsInput | null;
  minZoom?: number | null;
  maxZoom?: number | null;
}

export interface WorldMapInitialInputBoundsInput {
  topLeft?: CoordinatesInput | null;
  bottomRight?: CoordinatesInput | null;
  padding?: number | null;
}

export interface WorldMapInput {
  title?: string | null;
  visibility?: EVisibility | null;
  initial?: WorldMapInitialInput | null;
  initialMobile?: WorldMapInitialInput | null;
  initialType?: EWorldMapInitialType | null;
  defaultStyles?: string[] | null;
  markerDetailStyle?: WorldMapMarkerDetailStyle | null;
  showOnMapZoom?: number | null;
  allowGeolocation?: boolean | null;
  customMapUrl?: string | null;
  imageMapBackgroundColor?: string | null;
  groupMarkerColor?: string | null;
  groupMarkerBackground?: string | null;
  groupMarkerClusterMaxZoom?: number | null;
  groupMarkerClusterRadius?: number | null;
  fillCountryCodes?: string[] | null;
  fillCountryColor?: string | null;
  fillCountryOpacity?: number | null;
  autoHideIcons?: boolean | null;
  imageGallery?: string[] | null;
  iconGallery?: string[] | null;
  imageBackgroundUrl?: string | null;
  imageBackgroundCoordinates?: CoordinatesInput[] | null;
  showHighlightedCategory?: boolean | null;
  showList?: boolean | null;
  showSearch?: boolean | null;
}

export interface WorldMapMarkerDataDirectionInput {
  start?: CoordinatesInput | null;
  end?: CoordinatesInput | null;
  coordinates?: CoordinatesInput[] | null;
  path?: CoordinatesInput[] | null;
  transport?: string | null;
  color?: string | null;
  opacity?: number | null;
  width?: number | null;
  dropShadowColor?: string | null;
}

export interface WorldMapMarkerDataDrawInput {
  type?: string | null;
  path?: string | null;
  width?: number | null;
  height?: number | null;
  opacity?: number | null;
  strokeWidth?: number | null;
  fill?: boolean | null;
  color?: string | null;
}

export interface WorldMapMarkerDataIconV2Input {
  imageUrl?: string | null;
  text?: string | null;
  imageSize?: number | null;
  textSize?: number | null;
  textColor?: string | null;
  textHaloColor?: string | null;
  textHaloWidth?: number | null;
  generatedBackgroundColor?: string | null;
  generatedIconUrl?: string | null;
  generatedIconColor?: string | null;
  generatedImageUrl?: string | null;
  generatedEmoji?: string | null;
  rawPaintAttributes?: any | null;
  rawLayoutAttributes?: any | null;
}

export interface WorldMapMarkerDataImageInput {
  src?: string | null;
  srcWidth?: number | null;
  lat?: number | null;
  lng?: number | null;
  borderRadiusPx?: number | null;
  borderSize?: number | null;
  borderColor?: string | null;
  dropShadowCombined?: string | null;
  renderAsLayer?: boolean | null;
  layerData?: WorldMapMarkerDataImageLayerDataInput | null;
}

export interface WorldMapMarkerDataImageLayerDataInput {
  topLeft?: CoordinatesInput | null;
  topRight?: CoordinatesInput | null;
  bottomLeft?: CoordinatesInput | null;
  bottomRight?: CoordinatesInput | null;
}

export interface WorldMapMarkerDataImageV2Input {
  imageUrl?: string | null;
  coordinates?: CoordinatesInput[] | null;
  nonRotatedCoordinates?: CoordinatesInput[] | null;
  rotation?: number | null;
  opacity?: number | null;
  flipHorizontal?: boolean | null;
  flipVertical?: boolean | null;
  generatedImageUrl?: string | null;
  generatedBackgroundColor?: string | null;
  generatedIconColor?: string | null;
  generatedIconUrl?: string | null;
  generatedEmoji?: string | null;
}

export interface WorldMapMarkerDataIndoorStandInput {
  text?: string | null;
  textColor?: string | null;
  textHaloColor?: string | null;
  textHaloWidth?: number | null;
  pinGeneratedType?: string | null;
  pinGeneratedImageUrl?: string | null;
  pinGeneratedIconUrl?: string | null;
  pinGeneratedIconColor?: string | null;
  logoGeneratedImageUrl?: string | null;
  logoGeneratedStyleId?: string | null;
  pinSrc?: string | null;
  imageSrc?: string | null;
}

export interface WorldMapMarkerDataLineV2DashedInput {
  isDashed?: boolean | null;
  lineLength?: number | null;
  gapLength?: number | null;
}

export interface WorldMapMarkerDataLineV2Input {
  coordinates?: CoordinatesInput[] | null;
  color?: string | null;
  opacity?: number | null;
  width?: number | null;
  dashed?: WorldMapMarkerDataLineV2DashedInput | null;
  rawPaintAttributes?: any | null;
  rawLayoutAttributes?: any | null;
}

export interface WorldMapMarkerDataLinkInput {
  link?: string | null;
  text?: string | null;
  width?: number | null;
  color?: string | null;
  borderRadiusPx?: number | null;
  borderSize?: number | null;
  borderColor?: string | null;
  dropShadowCombined?: string | null;
}

export interface WorldMapMarkerDataPinIconInput {
  iconColor?: string | null;
  iconText?: string | null;
  backgroundColor?: string | null;
}

export interface WorldMapMarkerDataPinInput {
  label?: string | null;
  img?: string | null;
  emoji?: string | null;
  dotColor?: string | null;
  icon?: WorldMapMarkerDataPinIconInput | null;
}

export interface WorldMapMarkerDataPolygon3dDataInput {
  level?: number | null;
  baseHeight?: number | null;
  height?: number | null;
  color?: string | null;
}

export interface WorldMapMarkerDataPolygonInput {
  path?: string | null;
  coordinates?: CoordinatesInput[] | null;
  width?: number | null;
  height?: number | null;
  color?: string | null;
  fill?: boolean | null;
  renderAs3d?: boolean | null;
  data3d?: WorldMapMarkerDataPolygon3dDataInput | null;
}

export interface WorldMapMarkerDataPolygonV2BorderInput {
  hasBorder?: boolean | null;
  color?: string | null;
  width?: number | null;
  opacity?: number | null;
  rawPaintAttributes?: any | null;
  rawLayoutAttributes?: any | null;
}

export interface WorldMapMarkerDataPolygonV2FillInput {
  isFilled?: boolean | null;
  color?: string | null;
  opacity?: number | null;
  rawPaintAttributes?: any | null;
  rawLayoutAttributes?: any | null;
}

export interface WorldMapMarkerDataPolygonV2Input {
  coordinates?: CoordinatesInput[] | null;
  fill?: WorldMapMarkerDataPolygonV2FillInput | null;
  border?: WorldMapMarkerDataPolygonV2BorderInput | null;
}

export interface WorldMapMarkerDataReactComponentDataInput {
  name: string;
  value: string;
}

export interface WorldMapMarkerDataReactInput {
  componentTypeId?: string | null;
  componentData?: WorldMapMarkerDataReactComponentDataInput[] | null;
}

export interface WorldMapMarkerDataRouteInput {
  coordinates?: CoordinatesInput[] | null;
  fillColor?: string | null;
  fillColorOpacity?: number | null;
  lineColor?: string | null;
  lineOpacity?: number | null;
  dropShadowColor?: string | null;
}

export interface WorldMapMarkerDataRouteV2DashedInput {
  isDashed?: boolean | null;
  lineLength?: number | null;
  gapLength?: number | null;
}

export interface WorldMapMarkerDataRouteV2Input {
  coordinates?: CoordinatesInput[] | null;
  color?: string | null;
  opacity?: number | null;
  width?: number | null;
  dashed?: WorldMapMarkerDataRouteV2DashedInput | null;
}

export interface WorldMapMarkerDataTextInput {
  text?: string | null;
  width?: number | null;
  fill?: boolean | null;
  textColor?: string | null;
  textShadow?: string | null;
  color?: string | null;
  borderRadiusPx?: number | null;
  borderSize?: number | null;
  borderColor?: string | null;
  dropShadowCombined?: string | null;
}

export interface WorldMapMarkerDataTextV2Input {
  imageUrl?: string | null;
  coordinates?: CoordinatesInput[] | null;
  nonRotatedCoordinates?: CoordinatesInput[] | null;
  rotation?: number | null;
  generatedText?: string | null;
  generatedTextColor?: string | null;
  generatedBackgroundColor?: string | null;
  generatedWidth?: number | null;
  lineLength?: number | null;
  rawPaintAttributes?: any | null;
  rawLayoutAttributes?: any | null;
}

export interface WorldMapMarkerDataVariantIconV2Input {
  text?: string | null;
  color?: string | null;
  imageUrl?: string | null;
  useStoryImage?: boolean | null;
  circleText?: string | null;
  withStar?: boolean | null;
  eventDate?: string | null;
}

export interface WorldMapMarkerDataWallV2Input {
  coordinates?: CoordinatesInput[] | null;
  nonTransformedCoordinates?: CoordinatesInput[] | null;
  rotation?: number | null;
  scale?: number | null;
  label?: string | null;
  wall?: WorldMapMarkerDataWallV2WallInput | null;
  line?: WorldMapMarkerDataWallV2LineInput | null;
}

export interface WorldMapMarkerDataWallV2LineInput {
  isLine?: boolean | null;
  hasFloor?: boolean | null;
  fillColor?: string | null;
  width?: number | null;
}

export interface WorldMapMarkerDataWallV2WallInput {
  color?: string | null;
  height?: number | null;
  baseHeight?: number | null;
  opacity?: number | null;
}

export interface WorldMapMarkerDataYoutubeInput {
  video?: string | null;
  borderRadiusPx?: number | null;
  borderSize?: number | null;
  borderColor?: string | null;
  dropShadowCombined?: string | null;
}

export interface WorldMapMarkerInput {
  lat?: number | null;
  lng?: number | null;
  storyId?: string | null;
  storyIds?: string[] | null;
  scale?: number | null;
  locked?: boolean | null;
  scalable?: boolean | null;
  layerTitle?: string | null;
  placeId?: string | null;
  placeText?: string | null;
  visible?: boolean | null;
  isGroupable?: boolean | null;
  roomName?: string | null;
  isRoomMarker?: boolean | null;
  rotate?: number | null;
  order?: number | null;
  gptContextId?: string | null;
  type?: EWorldMapMarkerType | null;
  visibility?: EVisibility | null;
  data?: WorldMapMarkerInputData | null;
}

export interface WorldMapMarkerInputData {
  pin?: WorldMapMarkerDataPinInput | null;
  youtube?: WorldMapMarkerDataYoutubeInput | null;
  text?: WorldMapMarkerDataTextInput | null;
  image?: WorldMapMarkerDataImageInput | null;
  route?: WorldMapMarkerDataRouteInput | null;
  draw?: WorldMapMarkerDataDrawInput | null;
  polygon?: WorldMapMarkerDataPolygonInput | null;
  direction?: WorldMapMarkerDataDirectionInput | null;
  link?: WorldMapMarkerDataLinkInput | null;
  react?: WorldMapMarkerDataReactInput | null;
  lineV2?: WorldMapMarkerDataLineV2Input | null;
  polygonV2?: WorldMapMarkerDataPolygonV2Input | null;
  iconV2?: WorldMapMarkerDataIconV2Input | null;
  variantIconV2?: WorldMapMarkerDataVariantIconV2Input | null;
  textV2?: WorldMapMarkerDataTextV2Input | null;
  wallV2?: WorldMapMarkerDataWallV2Input | null;
  imageV2?: WorldMapMarkerDataImageV2Input | null;
  routeV2?: WorldMapMarkerDataRouteV2Input | null;
  indoorStand?: WorldMapMarkerDataIndoorStandInput | null;
}

export interface WorldMapSetInput {
  title?: string | null;
  color?: string | null;
  imageUrl?: string | null;
  isVisibleOnLoad?: boolean | null;
  orderIndex?: number | null;
  type?: EWorldMapSetType | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
